import React from 'react'
import { StyledHeading } from './styled'

const SubsectionHeading = ({ children }) => {
	return <StyledHeading>{children}</StyledHeading>
}

export default SubsectionHeading
